
<div
  v-if="html"
  v-b-popover.hover="{ html: true, content: `<pre class='field-hint-pre'>${html}</pre>`, customClass: 'field-hint-popover' }"
  :class="className"
>
  <Icon icon="question-circle" size="18" />
</div>
<div v-else v-b-popover.hover="text" :class="className">
  <Icon icon="question-circle" size="18" />
</div>
